<template>
  <div class="orderManagement-view">
    <el-tabs v-model="activeName"  @tab-click="handleClick">
      <el-tab-pane :label="$t('customer', 'myFollowUpAnalysis')" name="first">
        <mine v-if="activeName == 'first'" />
      </el-tab-pane>
      <el-tab-pane :label="$t('customer', 'enterpriseFollowUpAnalysis')" name="second">
        <enterprise v-if="activeName == 'second'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import mine from "./components/followUpAnalyse/mine";
import enterprise from "./components/followUpAnalyse/enterprise";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  name: "orderManagement",
  mixins: [i18nMixin],
  components: {
    mine,
    enterprise,
  },
  data() {
    return {
      activeName: "first",
    };
  },
  methods: {
    handleClick(tab) {
      const { name } = tab;
      this.activeName = name;
    },
  },
};
</script>

<style scoped lang='sass'>
</style>